<template>
  <router-view />
  <modals-container></modals-container>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { initChatling } from "/@/chatling/chatling";

onMounted(() => {
  initChatling();
});
</script>

<style lang="postcss" scoped></style>
